import { useMemo } from "react"
import type { IHasOwner, JwtToken } from "../redux"
import { useAuthenticatedUser } from "../components/indentity-provider.component"

export function useIsOwner(data: IHasOwner): boolean {
  const user = useAuthenticatedUser()

  const isOwner: boolean = useMemo<boolean>(() => {
    return user.udbId === data.profileId
  }, [user.udbId, data.profileId])

  return isOwner
}
